import { cn } from '@/lib/utils';
import { TriangleAlert } from 'lucide-react';

interface ErrorMessageProps {
	error: string;
	className?: string;
}

const ErrorMessage = ({ error, className }: ErrorMessageProps) => {
	return (
		<div className="flex items-end gap-1">
			<TriangleAlert className="size-4 text-red-600" />
			<span
				className={cn(
					'text-sm font-medium leading-3 text-red-500',
					className,
				)}
			>
				{error}
			</span>
		</div>
	);
};

export { ErrorMessage };
